import { AnaColumn } from "../forms-template.service";

export const rettifica: AnaColumn[] = [
  {
    itemType: 'group',
    caption: '',
    captionClass: 'd-none',
    class: '',
    groupDataField: 'MotivazioneRettifica',
    colCount: 1,
    data: [
      {
        type: 'campoDesc', dataField: 'info',
        defaultValue: "Eliminando questa riga verrà generata una <strong>rettifica di annullamento</strong> legata al movimento.<br/> Se si vuole procedere inserire la motivazione della cancellazione.",
        labelVisible: false,
        colVisible: false,
        class: 'msg-rettifica',
        colSpan: 2,
      },
      {
        type: 'campo',
        dataField: 'Motivazione',
        colVisible: true,
        editorType: 'dxTextArea',
        dataType: 'string',
        caption: 'Motivazione',
        height: 300,
        validation: [
          { type: 'required', message: 'Inserire una motivazione di rettifica' }
        ],
        labelVisible: false,
        colAlignment: 'left',
        nCol: 10,
      },
      { type: 'campo', dataType: 'string', visible: false, dataField: 'idRelaz' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
    ]
  }
]